<template>
  <div>
    <div class="toolbar">
      <el-input v-model="query.companyNumber" clearable placeholder="编码" style="width:160px" @keyup.enter.native="search" />
      <el-input v-model="query.companyName" clearable placeholder="名称" style="width:160px" @keyup.enter.native="search" />
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
    </div>
    <el-table :data="list" border v-loading="loading">
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="companyNumber" label="编码" width="140" />
      <el-table-column prop="companyName" label="名称" min-width="160" show-overflow-tooltip />
      <el-table-column label="供应商" width="80" align="center">
        <template slot-scope="{ row }">{{ row.isSupplier === '1' ? '是' : '否' }}</template>
      </el-table-column>
      <el-table-column label="客户" width="80" align="center">
        <template slot-scope="{ row }">{{ row.isReceiver === '1' ? '是' : '否' }}</template>
      </el-table-column>
      <el-table-column label="启用" width="80" align="center">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="row.active === '1' ? 'success' : 'info'">{{ row.active === '1' ? '是' : '否' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row.companyId)">修改</el-button>
          <el-button type="text" style="color:#ef4444" @click="onDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage" @size-change="onSize"
    />

    <el-dialog :title="form.companyId ? '修改公司' : '新增公司'" :visible.sync="visible" width="760px" :close-on-click-modal="false">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="基本信息" name="base">
          <el-form ref="form" :model="form" :rules="rules" label-width="110px">
            <el-form-item label="编码" prop="companyNumber"><el-input v-model="form.companyNumber" /></el-form-item>
            <el-form-item label="名称" prop="companyName"><el-input v-model="form.companyName" /></el-form-item>
            <el-form-item label="税号"><el-input v-model="form.tax" /></el-form-item>
            <el-form-item label="电话"><el-input v-model="form.phone" /></el-form-item>
            <el-form-item label="邮箱"><el-input v-model="form.email" /></el-form-item>
            <el-form-item label="网站"><el-input v-model="form.website" /></el-form-item>
            <el-form-item label="默认街道"><el-input v-model="form.street" /></el-form-item>
            <el-form-item label="默认城市"><el-input v-model="form.city" /></el-form-item>
            <el-form-item label="默认邮编"><el-input v-model="form.zipCode" /></el-form-item>
            <el-form-item label="默认联系人"><el-input v-model="form.contactPerson" /></el-form-item>
            <el-form-item label="供应商"><el-switch v-model="form.isSupplier" active-value="1" inactive-value="0" /></el-form-item>
            <el-form-item label="客户"><el-switch v-model="form.isReceiver" active-value="1" inactive-value="0" /></el-form-item>
            <el-form-item label="启用"><el-switch v-model="form.active" active-value="1" inactive-value="0" /></el-form-item>
            <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="2" /></el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="地址" name="address" :disabled="!form.companyId">
          <div style="margin-bottom:8px">
            <el-button type="primary" size="mini" @click="openAddress()">新增地址</el-button>
          </div>
          <el-table :data="addresses" border size="mini" v-loading="childLoading">
            <el-table-column prop="addressName" label="名称" min-width="100" />
            <el-table-column label="类型" width="80">
              <template slot-scope="{ row }">{{ addressTypeLabel(row.addressType) }}</template>
            </el-table-column>
            <el-table-column prop="street" label="街道" min-width="120" show-overflow-tooltip />
            <el-table-column prop="city" label="城市" width="90" />
            <el-table-column label="主地址" width="70" align="center">
              <template slot-scope="{ row }">{{ row.isPrimary === '1' ? '是' : '否' }}</template>
            </el-table-column>
            <el-table-column label="操作" width="120" align="center">
              <template slot-scope="{ row }">
                <el-button type="text" size="mini" @click="openAddress(row)">改</el-button>
                <el-button type="text" size="mini" @click="removeAddress(row)">删</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="联系人" name="contact" :disabled="!form.companyId">
          <div style="margin-bottom:8px">
            <el-button type="primary" size="mini" @click="openContact()">新增联系人</el-button>
          </div>
          <el-table :data="contacts" border size="mini" v-loading="childLoading">
            <el-table-column prop="contactName" label="姓名" min-width="100" />
            <el-table-column prop="title" label="职务" width="100" />
            <el-table-column prop="phone" label="电话" width="120" />
            <el-table-column prop="email" label="邮箱" min-width="140" show-overflow-tooltip />
            <el-table-column label="主联系人" width="80" align="center">
              <template slot-scope="{ row }">{{ row.isPrimary === '1' ? '是' : '否' }}</template>
            </el-table-column>
            <el-table-column label="操作" width="120" align="center">
              <template slot-scope="{ row }">
                <el-button type="text" size="mini" @click="openContact(row)">改</el-button>
                <el-button type="text" size="mini" @click="removeContact(row)">删</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer">
        <el-button @click="visible = false">关闭</el-button>
        <el-button type="primary" :loading="saving" @click="submit">保存基本信息</el-button>
      </div>
    </el-dialog>

    <el-dialog title="地址" :visible.sync="addressVisible" width="480px" append-to-body :close-on-click-modal="false">
      <el-form :model="addressForm" label-width="90px">
        <el-form-item label="编码"><el-input v-model="addressForm.addressNumber" /></el-form-item>
        <el-form-item label="名称"><el-input v-model="addressForm.addressName" /></el-form-item>
        <el-form-item label="类型">
          <el-select v-model="addressForm.addressType" style="width:100%">
            <el-option label="办公" value="01" />
            <el-option label="收货" value="02" />
            <el-option label="发货" value="03" />
            <el-option label="其它" value="99" />
          </el-select>
        </el-form-item>
        <el-form-item label="街道"><el-input v-model="addressForm.street" /></el-form-item>
        <el-form-item label="城市"><el-input v-model="addressForm.city" /></el-form-item>
        <el-form-item label="邮编"><el-input v-model="addressForm.zipCode" /></el-form-item>
        <el-form-item label="电话"><el-input v-model="addressForm.phone" /></el-form-item>
        <el-form-item label="邮箱"><el-input v-model="addressForm.email" /></el-form-item>
        <el-form-item label="联系人"><el-input v-model="addressForm.contactPerson" /></el-form-item>
        <el-form-item label="主地址"><el-switch v-model="addressForm.isPrimary" active-value="1" inactive-value="0" /></el-form-item>
        <el-form-item label="启用"><el-switch v-model="addressForm.active" active-value="1" inactive-value="0" /></el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="addressVisible = false">取消</el-button>
        <el-button type="primary" :loading="childSaving" @click="submitAddress">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="联系人" :visible.sync="contactVisible" width="440px" append-to-body :close-on-click-modal="false">
      <el-form :model="contactForm" label-width="90px">
        <el-form-item label="姓名"><el-input v-model="contactForm.contactName" /></el-form-item>
        <el-form-item label="职务"><el-input v-model="contactForm.title" /></el-form-item>
        <el-form-item label="电话"><el-input v-model="contactForm.phone" /></el-form-item>
        <el-form-item label="邮箱"><el-input v-model="contactForm.email" /></el-form-item>
        <el-form-item label="主联系人"><el-switch v-model="contactForm.isPrimary" active-value="1" inactive-value="0" /></el-form-item>
        <el-form-item label="启用"><el-switch v-model="contactForm.active" active-value="1" inactive-value="0" /></el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="contactVisible = false">取消</el-button>
        <el-button type="primary" :loading="childSaving" @click="submitContact">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import {
  listMesCompany, getMesCompany, saveMesCompany, updateMesCompany, deleteMesCompany,
  listCompanyAddress, saveCompanyAddress, updateCompanyAddress, deleteCompanyAddress,
  listCompanyContact, saveCompanyContact, updateCompanyContact, deleteCompanyContact
} from '../../api/mesCompany'

const ADDRESS_TYPES = { '01': '办公', '02': '收货', '03': '发货', '99': '其它' }

function emptyForm() {
  return {
    companyId: '', companyNumber: '', companyName: '', tax: '', phone: '', email: '', website: '',
    street: '', city: '', zipCode: '', contactPerson: '', isSupplier: '0', isReceiver: '0', active: '1', remark: ''
  }
}
function emptyAddress() {
  return {
    addressId: '', companyId: '', addressNumber: '', addressName: '', addressType: '01',
    street: '', city: '', zipCode: '', phone: '', email: '', contactPerson: '', isPrimary: '0', active: '1'
  }
}
function emptyContact() {
  return {
    contactId: '', companyId: '', contactName: '', title: '', phone: '', email: '', isPrimary: '0', active: '1'
  }
}

export default {
  name: 'MesBizCompany',
  components: { ListPagination },
  data() {
    return {
      query: { companyNumber: '', companyName: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false,
      visible: false, saving: false, activeTab: 'base', form: emptyForm(),
      addresses: [], contacts: [], childLoading: false, childSaving: false,
      addressVisible: false, addressForm: emptyAddress(),
      contactVisible: false, contactForm: emptyContact(),
      rules: {
        companyNumber: [{ required: true, message: '请填写编码', trigger: 'blur' }],
        companyName: [{ required: true, message: '请填写名称', trigger: 'blur' }]
      }
    }
  },
  created() { this.load() },
  methods: {
    addressTypeLabel(v) { return ADDRESS_TYPES[v] || v || '' },
    indexMethod(i) { return (this.page - 1) * this.pageSize + i + 1 },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listMesCompany({
        currentPage: this.page, pageSize: this.pageSize,
        companyNumber: this.query.companyNumber, companyName: this.query.companyName
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    openEdit(id) {
      this.form = emptyForm()
      this.addresses = []
      this.contacts = []
      this.activeTab = 'base'
      this.visible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
      if (!id) return
      getMesCompany(id).then(res => {
        this.form = Object.assign(emptyForm(), res.data || {})
        this.loadChildren()
      })
    },
    loadChildren() {
      if (!this.form.companyId) return
      this.childLoading = true
      Promise.all([
        listCompanyAddress(this.form.companyId),
        listCompanyContact(this.form.companyId)
      ]).then(([a, c]) => {
        this.addresses = a.data || []
        this.contacts = c.data || []
      }).finally(() => { this.childLoading = false })
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.saving = true
        const req = this.form.companyId ? updateMesCompany(this.form) : saveMesCompany(this.form)
        req.then(res => {
          if (!this.form.companyId && res.data) this.form.companyId = res.data
          this.$message.success('保存成功')
          this.load()
          this.loadChildren()
        }).finally(() => { this.saving = false })
      })
    },
    onDelete(row) {
      this.$confirm('确定删除？', '提示', { type: 'warning' }).then(() => {
        deleteMesCompany([row.companyId]).then(() => {
          this.$message.success('已删除')
          this.load()
        })
      }).catch(() => {})
    },
    openAddress(row) {
      this.addressForm = Object.assign(emptyAddress(), row || { companyId: this.form.companyId })
      this.addressForm.companyId = this.form.companyId
      this.addressVisible = true
    },
    submitAddress() {
      this.childSaving = true
      const req = this.addressForm.addressId ? updateCompanyAddress(this.addressForm) : saveCompanyAddress(this.addressForm)
      req.then(() => {
        this.$message.success('保存成功')
        this.addressVisible = false
        this.loadChildren()
      }).finally(() => { this.childSaving = false })
    },
    removeAddress(row) {
      this.$confirm('确定删除该地址？', '提示', { type: 'warning' }).then(() => {
        deleteCompanyAddress([row.addressId]).then(() => this.loadChildren())
      }).catch(() => {})
    },
    openContact(row) {
      this.contactForm = Object.assign(emptyContact(), row || { companyId: this.form.companyId })
      this.contactForm.companyId = this.form.companyId
      this.contactVisible = true
    },
    submitContact() {
      if (!this.contactForm.contactName) {
        this.$message.warning('请填写联系人姓名')
        return
      }
      this.childSaving = true
      const req = this.contactForm.contactId ? updateCompanyContact(this.contactForm) : saveCompanyContact(this.contactForm)
      req.then(() => {
        this.$message.success('保存成功')
        this.contactVisible = false
        this.loadChildren()
      }).finally(() => { this.childSaving = false })
    },
    removeContact(row) {
      this.$confirm('确定删除该联系人？', '提示', { type: 'warning' }).then(() => {
        deleteCompanyContact([row.contactId]).then(() => this.loadChildren())
      }).catch(() => {})
    }
  }
}
</script>
